module.exports = __webpack_public_path__ + "img/man-sit.4f5f63a8.svg";